import { atom } from "jotai";

export type ComparisonFilter = "all" | "ai_only" | "agreement" | "report_only";

export const comparisonFilterAtom = atom<ComparisonFilter>("all");
